import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import CampaignBudgetSectionForm from '../../../../../ReusableFormSections/reusableBudgetSections/FacebookBudgetSections/FacebookCampaignBudgetSection/CampaignBudgetSectionForm'
import FacebookCampaignBudgetFields from './FacebookCampaignBudgetFields'

import { getBudgetSectionType } from '../../../../../Multiplatform/CampaignForms/typeHelpers'

import { selectedFacebookAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { NO_BUDGET } from '../../../../../Multiplatform/CampaignForms/fields'
import { FACEBOOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'

import useStyles from '../../../../../../styles/common/drawerForms'

const BudgetSection = ({ editItemData: campaign, ...formProps }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const { budget_lifetime: initialBudgetLifetime, budget_daily: initialBudgetDaily } = campaign
  const budgetType = getBudgetSectionType(initialBudgetLifetime, initialBudgetDaily)

  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)

  return budgetType === NO_BUDGET ? (
    <div className={classes.sectionPreview}>
      <p>{t('Budgets for this campaign are set at an ad set level. Please edit your ad sets to manage the budget.')}</p>
    </div>
  ) : (
    <CampaignBudgetSectionForm
      campaign={campaign}
      budgetType={budgetType}
      platform={FACEBOOK_PLATFORM}
      CampaignBudgetFormFields={FacebookCampaignBudgetFields}
      adAccountId={selectedAdAccountId}
      {...formProps}
    />
  )
}

export default BudgetSection
